import React, { memo } from 'react';
import { Text, useTPAComponentsContext } from '@wix/wix-ui-tpa/cssVars';
import { useTranslation } from '@wix/yoshi-flow-editor';
import { st, classes } from '../../Widget.st.css';
import SelectedLayout from '../SelectedLayout/SelectedLayout';
import { QuestionEntry } from '@wix/ambassador-faq-question-entry-v2-question-entry/types';
import { DATA_HOOKS } from '../../../../../constants/dataHooksElements';
import { areQuestionsEqual } from '../../../../../hooks/useQuestions';

export interface Props {
  questionsList: QuestionEntry[];
  searchTerm?: string;
  numberLayout?: boolean;
  accordionLayout?: boolean;
  listLayout?: boolean;
}

const DEFAULT_ACCORDION_LAYOUT = true;

const QuestionsResultsFoundComponent = ({
  questionsList,
  searchTerm = '',
  numberLayout = false,
  accordionLayout = DEFAULT_ACCORDION_LAYOUT,
  listLayout = false,
}: Props) => {
  const { mobile } = useTPAComponentsContext();
  const { t } = useTranslation();
  return (
    <>
      <div
        className={st(classes.searchMessage, {
          resultFound: !!searchTerm,
          mobile,
        })}
        data-hook={DATA_HOOKS.WIDGET_QUESTIONS_RESULTS_FOUND}
      >
        {searchTerm && (
          <div className={st(classes.searchResultText)}>
            <Text data-hook={DATA_HOOKS.TEXT_SEARCH_RESULTS_FOUND}>
              {t('widget.search.tab.results.found', { searchTerm })}
            </Text>
          </div>
        )}
      </div>
      <SelectedLayout
        filteredQuestions={questionsList}
        numberLayout={numberLayout}
        accordionLayout={accordionLayout}
        listLayout={listLayout}
      />
    </>
  );
};

const QuestionsResultsFound = memo(
  QuestionsResultsFoundComponent,
  (prev, next) =>
    areQuestionsEqual(prev.questionsList, next.questionsList) &&
    (prev.searchTerm ?? '') === (next.searchTerm ?? '') &&
    prev.numberLayout === next.numberLayout &&
    prev.accordionLayout === next.accordionLayout &&
    prev.listLayout === next.listLayout,
);

QuestionsResultsFound.displayName = 'QuestionsResultsFound';

export default QuestionsResultsFound;
